const CSS_CLASSES = {
	POPUP: 'search-popup',
	SEARCH: 'title-search',
	SEARCH_ITEM: 'title-search__item',
	SEARCH_ITEM_SELECTED: 'title-search__item--selected',
	SEARCH_LINK: 'title-search__link'
};

export default class RSTitleSearch extends JCTitleSearch
{
	constructor(arParams)
	{
		super(arParams);

		this.isFocused = false;

		const parent = document.querySelector(`.${CSS_CLASSES.POPUP}`);
		parent.appendChild(this.RESULT);

		function ShowResult(result)
		{
			if(BX.type.isString(result))
				this.RESULT.innerHTML = result;

			const isVisible = this.RESULT.style.display === 'block';
			if (isVisible)
			{
				if (this.RESULT.innerHTML === '')
					this.hideResult();
				else
					this.adjustResultNode();
			}
			else
			{
				if (this.RESULT.innerHTML !== '')
					this.showResult();
			}
		}

		function EnableMouseEvents()
		{
			const rows = this.RESULT.querySelectorAll(`.${CSS_CLASSES.SEARCH_ITEM}`);

			rows.forEach((row, index) => {
				row.addEventListener('mouseover', () => {
					this.currentRow = index;

					this.unSelectRows();
					this.selectRow(this.currentRow);
				});
				row.addEventListener('click', ({ target }) => {
					const link = target.querySelector(`.${CSS_CLASSES.SEARCH_LINK}`);
					if (link)
						link.click();
				});
			});
		}

		function onKeyPress(keyCode)
		{
			const rows = this.RESULT.querySelectorAll(`.${CSS_CLASSES.SEARCH_ITEM}`);

			switch(keyCode)
			{
				case 27: // escape key
					this.hideResult();
					this.currentRow = -1;
					this.unSelectRows();

					this.INPUT.blur();

					return true;

				case 40: // down key
					if (this.currentRow + 1 >= rows.length)
						this.currentRow = -1;
					else
						++this.currentRow;

					this.unSelectRows();
					this.selectRow(this.currentRow);

					return true;

				case 38: // up key
					if (this.currentRow <= -1)
						this.currentRow = rows.length - 1;
					else
						--this.currentRow;

					this.unSelectRows();
					this.selectRow(this.currentRow);

					return true;

				case 13: // Enter

					if (rows[this.currentRow])
					{
						const link = rows[this.currentRow].querySelector(`.${CSS_CLASSES.SEARCH_LINK}`);
						if (link)
						{
							link.click();
							return true;
						}
					}

					return false;

			}
		}

		function adjustResultNode()
		{
			if(!(BX.type.isElementNode(this.RESULT)
				&& BX.type.isElementNode(this.CONTAINER))
			)
			{
				return { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
			}

			var pos = this.CONTAINER.getBoundingClientRect();

			this.RESULT.style.position = 'absolute';
			this.RESULT.style.top = (pos.bottom + 2) + 'px';
			this.RESULT.style.left = pos.left + 'px';
			this.RESULT.style.width = pos.width + 'px';
			this.RESULT.style.height = 'auto';

			setTimeout(() => {
				const resultRect = this.RESULT.getBoundingClientRect();
				const screenHeight = window.innerHeight;
				if (window.matchMedia('(max-width: 575px)').matches)
					this.RESULT.style.height = (screenHeight - resultRect.top) + 'px';
				else if (resultRect.bottom >= screenHeight)
					this.RESULT.style.height = (screenHeight - resultRect.top - 2) + 'px';

			});

			return pos;
		}

		function onFocusLost()
		{
			setTimeout(() => {
				this.isFocused = false;
				this.hideResult();
				this.unSelectRows();
				this.currentRow = -1;
			}, 250);
		}

		function onFocusGain()
		{
			this.isFocused = true;
			if(this.RESULT.innerHTML.length)
				this.ShowResult();
		}

		this.ShowResult = ShowResult.bind(this);
		this.onKeyPress = onKeyPress.bind(this);
		this.EnableMouseEvents = EnableMouseEvents.bind(this);
		this.adjustResultNode = adjustResultNode.bind(this);
		this.onFocusLost = onFocusLost.bind(this);
		this.onFocusGain = onFocusGain.bind(this);

		window.addEventListener('resize', () => {
			if(BX.type.isElementNode(this.RESULT)
				&& this.RESULT.style.display !== "none"
				&& this.RESULT.innerHTML !== ''
			)
			{
				this.adjustResultNode();
			}
		});
	}

	hideResult()
	{
		if (this.isFocused)
			return;

		this.RESULT.style.opacity = 0;
		const handleAnimation = () => {
			if (this.RESULT.style.opacity > 0)
			{
				window.requestAnimationFrame(handleAnimation);
			}
			else
			{
				this.RESULT.style.opacity = 1;
				this.RESULT.style.display = 'none';
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}

	showResult()
	{
		if (!this.isFocused)
			return;

		this.adjustResultNode();
		this.RESULT.style.opacity = 0;
		this.RESULT.style.display = 'block';
		setTimeout(() => {
			this.RESULT.style.opacity = 1;
			this.adjustResultNode();
		});
	}

	unSelectRows()
	{
		const rows = this.RESULT.querySelectorAll(`.${CSS_CLASSES.SEARCH_ITEM}`);

		[...rows]
			.filter(row => row.classList.contains(CSS_CLASSES.SEARCH_ITEM_SELECTED))
			.forEach(row => row.classList.remove(CSS_CLASSES.SEARCH_ITEM_SELECTED));
	}

	selectRow(index)
	{
		const rows = this.RESULT.querySelectorAll(`.${CSS_CLASSES.SEARCH_ITEM}`);

		if (rows[index])
			rows[index].classList.add(CSS_CLASSES.SEARCH_ITEM_SELECTED);
	}
}